import MapButton from 'components/buttons/MapButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const EditMapButton: FunctionComponent<Props> = ({ className = '', onClick, testId = TEST_ID }) => (
    <MapButton className={className} onClick={onClick} testId={testId}>
        +
    </MapButton>
);

export default EditMapButton;
